module.exports = __webpack_public_path__ + "img/spinner.0836a709.gif";